import { render, staticRenderFns } from "./framepage.vue?vue&type=template&id=0bd18199&scoped=true&"
import script from "./framepage.vue?vue&type=script&lang=js&"
export * from "./framepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd18199",
  null
  
)

export default component.exports